import axios from 'axios';

export default axios.create({
	baseURL: process.env.VUE_APP_SERVER_BASE_URL + '/api/',
	headers: {
		'Cockpit-Token': process.env.VUE_APP_COCKPIT_API_KEY,
	},
});